import React from "react";
import { FlopppyButton, FlopppyButtonCancel } from "./ButtonWithLoading";
import { Select } from "antd";
const { Option, OptGroup } = Select;

const SelectInputWithGroups = ({
  options,
  value,
  onChange,
  loading,
  onClose,
  onSave,
}) => {
  return (
    <div className="d-flex">
      <Select
        className="mr-1"
        dropdownMatchSelectWidth={true}
        placeholder="Choose"
        style={{ minWidth: 181 }}
        // placeholder="Enter"
        value={value || undefined}
        onChange={onChange}
      >
        {Object.keys(options).map((group, i) => (
          <OptGroup key={`store_${group}`} label={group}>
          {options[group].map((item, index) => (
            <Option key={`${group}_${index}`} value={item.value}>
              {item.label}
            </Option>
          ))}
          </OptGroup>
        ))}
      </Select>
      <FlopppyButton className="ml-1" loading={loading} onClick={onSave} />
      {onClose && (
        <FlopppyButtonCancel
          className={`ml-1 ${loading && "invisible"}`}
          onClick={onClose}
        />
      )}
    </div>
  );
};

export default SelectInputWithGroups;
